<template>
  <div class="enroll-error">
    <div>
      <div v-if="errorReason === 'blacklisted'">
        Thanks for your interest! Based on our records, you are not eligible to enroll in this
        study at this time. If you believe this is an error, please contact us at
        support@morebetter.ltd with your phone number.
      </div>
      <div v-else-if="errorReason === 'study-restriction'">
        Sorry, you're not able to enroll in this study because our records show you already
        participated in this study or a related one. If you'd like to be notified about future study
        opportunities join <a href="https://morebetter.ltd/join-study">our study registry</a>.
      </div>
      <div v-else>
        Something went wrong with your enrollment. Please try again later or contact us at
        support@morebetter.ltd for assistance.
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'EnrollError',
  computed: {
    ...mapState(['errorReason']),
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_variables.scss';

.enroll-error {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
}

@media (min-width: $breakpoint-tablet) {
  .complete {
    justify-content: flex-start;
  }
}
</style>
